// extracted by mini-css-extract-plugin
export default {"swapsHistory":"Uy1RfwKToMnNFSBBt5n2"};